import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { StandardApiResponse } from '@app/interfaces/standard-api-response';
import { PaymentCardModel } from '@app/models/system-settings/payment-card.model';

@Injectable()
export class PurchaseCardSetupService {
	endpointBase = '/api/payment-cards';

	constructor(private readonly http: HttpClient) {}

	getCardByType(typeId: number): Observable<StandardApiResponse<PaymentCardModel>> {
		return this.http.get<StandardApiResponse<PaymentCardModel>>(this.endpointBase, {
			params: {
				typeId: typeId.toString(),
			},
		});
	}

	createOrUpdate(model: PaymentCardModel): Observable<StandardApiResponse<PaymentCardModel>> {
		return this.http.post<StandardApiResponse<PaymentCardModel>>(this.endpointBase, model);
	}

	searchVendorsForFilter(searchText: string): Observable<any> {
		return this.http.get(`/api/vendor/search`, {
			params: {
				limit: '10',
				name: searchText,
				topLevelOnly: 'true',
				statusId: '1',
			},
		});
	}

	getSites(): Observable<any> {
		return this.http.get(`/api/site/list`);
	}

	testConnection(hostName: string, userName: string, password: string, port: string, directory: string): Observable<any> {
		return this.http.get<any>(`${this.endpointBase}/testConnection`, {
			params: {
				hostName,
				userName,
				password,
				port,
				directory,
			},
		});
	}
}
